module.exports = __webpack_public_path__ + "img/courses9.88d0b581.jpg";